// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".OAXVo02qEg56bErNeAzdBw\\=\\={width:100%}", "",{"version":3,"sources":["webpack://./resources/js/pages/NewPost/NewPostForm/SectionsContainer/DeveloperSectionContainer/ApartmentsCard/ApartmentForm/FormSkeleton/styles.module.scss"],"names":[],"mappings":"AAAA,4BACI,UACJ","sourcesContent":[".container {\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "OAXVo02qEg56bErNeAzdBw=="
};
export default ___CSS_LOADER_EXPORT___;
